import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import styles from "./styles.module.scss";
import classNames from "classnames";

export const FileUploadDropzone: React.FC<{
  onFileSelect: (files: File[]) => void;
}> = ({ onFileSelect }) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDragEnter = (e: React.DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e: React.DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) setIsDragging(true);
  };

  const handleDrop = (e: React.DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files?.length) {
      onFileSelect(Array.from(e.dataTransfer.files));
    }
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      onFileSelect(Array.from(e.target.files));
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <button
      type="button"
      aria-label="Upload CSV files"
      className={classNames(styles.dropzone, isDragging && styles.dragging)}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onClick={handleBrowseClick}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileInput}
        accept=".csv"
        multiple
        className={styles.fileInput}
      />
      <div className={styles.dropzoneContent}>
        <Upload size={48} color="#5295E0" />
        <p className={styles.dropzoneText}>
          Drag & drop files or <span className={styles.browseText}>Browse</span>
        </p>
        <p className={styles.formatText}>Supported format: CSV</p>
      </div>
    </button>
  );
};
